import React from "react";
import Header from "./Components/Header/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Nav from "./Components/Nav/Nav";
import About from "./Components/About/About";
import Experience from "./Components/Experience/Experience";
import Footer from "./Components/Footer/Footer";
import Services from "./Components/Services/Secvices";
import Testimonials from "./Components/Testimonials/Testmonials";
import Contact from "./Components/Contact/Contact";
import Portfolio from "./Components/Portfolio/Portfolio";
import Details from "./Components/portfolioDetails/portfolioDetail";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <Nav />
              <About />
              <Experience />
              <Services />
              <Portfolio />
              <Testimonials />
              <Contact />
            </>
          }
        />
        <Route path="/portfolio/:url" element={<Details />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
